import { deepCopy } from '~/utils';
import { create } from 'zustand';

export type TDataUserAction = Record<string, string>;
export type TData = Record<string, TDataUserAction>;

interface IUserActionStore {
  data?: TData;
  setUserAction: (key: string, data: TDataUserAction) => void;
  getUserAction: (key: string) => TDataUserAction | undefined;
}

const userActionStore = create<IUserActionStore>((set, get) => ({
  data: undefined,

  setUserAction: (key: string, data: TDataUserAction) =>
    set((state) => {
      const updateData = deepCopy({
        ...(state.data ?? {}),
        [key]: data,
      });

      return {
        data: updateData,
      };
    }),
  getUserAction: (key: string) => get().data?.[key],
}));

export default userActionStore;
